import React, { Fragment, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { Row, Col, Input, Badge, Menu, Dropdown, Button, Form } from "antd";
import Notification from "../../../common/Notification/NotificationDesktop";
import { FaSearch, FaBell, FaAngleDown, FaBars } from "react-icons/fa";
import { AiTwotoneMessage } from "react-icons/ai";
import OrganizerDrawer from "../drawer/OrganizerDrawer";
import { KEYS } from "../../../Config/Keys";
import FadeInImage from "../../../common/Images/FadeInImage";
import { useCurrentPage } from "../../../common/hooks/useCurrentPage";
import { fallbackprofile } from "../../../common/Utils";
import { Info } from "../../../common/Alerts/Message";
import useVariables from "../../../common/hooks/useVariables";
import { useSelector } from "react-redux";

const OrganizerNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { query, id } = useParams();
  const [text, settext] = useState(query);
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false); // notification List
  const { url } = useCurrentPage();
  const flexTokens = useSelector((state) => state.wallet.flexTokens);

  const { viewer, panelid } = useVariables();
  const notClickable = pathname === "/organizer";

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const u = useRef(null);
  const p = useRef(null);
  const e = useRef(null);

  var currentflag = "organizer",
    currentid = viewer?.id;

  const UserItems = [
    {
      label: (
        <Link style={{ color: "var(--green)" }} to="/player">
          Switch to Player
        </Link>
      ),
      key: "switch",
      onClick: () => {
        localStorage.removeItem("ProfileID");
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        userDetails.role = "PLayer";
        localStorage.setItem("userDetails", JSON.stringify(userDetails));
      }
    },
    {
      type: "divider"
    },
    notClickable
      ? null
      : {
          label: <Link to="/organizer/wallet">FlexTokens: {flexTokens}</Link>,
          key: "wallet"
        },
    {
      type: "divider"
    },
    notClickable
      ? null
      : {
          label: <Link to="/organizer/timeline">My Profile</Link>,
          key: "profile"
        },
    {
      type: "divider"
    },
    notClickable
      ? null
      : {
          label: (
            <Link
              state={{ currentflag, currentid }}
              to={
                currentflag === "panel" && id
                  ? `/organizer/panel/${panelid || id}/settings`
                  : "/organizer/settings"
              }>
              Settings and Privacy
            </Link>
          ),
          key: "PrivacyandSettings"
        },
    {
      type: "divider"
    },
    {
      label: <Link to="/signin">Log out</Link>,
      key: "Logout",
      onClick: () => {
        localStorage.removeItem("ProfileID");
        localStorage.removeItem("userToken");
        localStorage.removeItem("userDetails");
        localStorage.removeItem("panel");
        localStorage.removeItem("viewer");
        localStorage.removeItem("CoverPic");
        localStorage.removeItem("ProfilerPic");
      }
    }
  ];

  const Panel = [
    {
      label: (
        <Link to="/organizer/search/panels" state={"panels"}>
          Join Panel
        </Link>
      ),
      key: "paneljoin"
    },
    {
      type: "divider"
    },
    {
      label: <Link to="/organizer/panels">My Panels</Link>,
      key: "panel"
    },
    {
      type: "divider"
    },
    {
      label: <Link to="/organizer/createpanel">Create Panel</Link>,
      key: "createPanel"
    }
  ];
  const Events = [
    {
      label: <Link to={`/organizer/createevent`}>Create Event</Link>,
      key: "createEvents"
    },
    {
      type: "divider"
    },
    {
      label: <Link to={`/organizer/events`}>Current Events</Link>,
      key: "currentevents"
    },
    {
      type: "divider"
    },
    {
      label: <Link to={`/organizer/events/pastevents`}>Past Events</Link>,
      key: "pastevents"
    },
    {
      type: "divider"
    },

    {
      label: <Link to={`/organizer/events/draftevents`}>Draft Events</Link>,
      key: "draftevents"
    }
  ];
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        onClose();
      }
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("load", onClose);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("load", onClose);
    };
  }, [pathname]);

  useEffect(() => {
    onClose();
  }, [pathname]);
  useEffect(() => {
    settext(query);
  }, [query]);

  // const formlength = (id === undefined || !id) && !panelid ? 8 : 6;

  const ALERT = () => Info("Create Profile First");
  return (
    <Fragment>
      <OrganizerDrawer onClose={onClose} visible={visible} />
      <Row className="mobileNav">
        <Col lg={4} md={4}>
          <Link to="/">
            <img className="navlogo" height="40px" src="/images/logo.png" alt="img" />
          </Link>
        </Col>
        <Col className="mobileNav" span={2}>
          {notClickable ? (
            <div onClick={ALERT} className={`Nav_a`}>
              Home
            </div>
          ) : (
            <Link to="/organizer/feed" className={`Nav_a ${url === "home" && "active"}`}>
              Home
            </Link>
          )}
        </Col>
        {
          // (pathname.includes("panel") && (id !== undefined || panelid)) ?
          id !== undefined || panelid ? (
            <Col className="mobileNav" span={2} ref={e}>
              {notClickable ? (
                <div onClick={ALERT}>
                  <span className={`Nav_a`}>
                    Events <FaAngleDown style={{ verticalAlign: "middle" }} />
                  </span>
                </div>
              ) : (
                <Dropdown
                  placement="bottom"
                  getPopupContainer={() => e.current}
                  overlay={<Menu items={Events} />}
                  trigger={["click"]}>
                  <a className={`ant-dropdown-link Nav_a ${url === "event" && "active"}`}>
                    Events <FaAngleDown style={{ verticalAlign: "middle" }} />
                  </a>
                </Dropdown>
              )}
            </Col>
          ) : (
            <Col className="mobileNav" span={2} ref={e}>
              {notClickable ? (
                <div onClick={ALERT}>
                  <span className={`Nav_a`}>
                    Events <FaAngleDown style={{ verticalAlign: "middle" }} />
                  </span>
                </div>
              ) : (
                <Dropdown
                  placement="bottom"
                  getPopupContainer={() => e.current}
                  overlay={<Menu items={Events} />}
                  trigger={["click"]}>
                  <a className={`ant-dropdown-link Nav_a ${url === "event" && "active"}`}>
                    Events <FaAngleDown style={{ verticalAlign: "middle" }} />
                  </a>
                </Dropdown>
              )}
            </Col>
          )
        }
        <Col className="mobileNav" span={2} ref={p}>
          {notClickable ? (
            <div onClick={ALERT}>
              <span className={`Nav_a`}>
                Panels <FaAngleDown style={{ verticalAlign: "middle" }} />
              </span>
            </div>
          ) : (
            <Dropdown
              placement="bottom"
              getPopupContainer={() => p.current}
              overlay={<Menu items={Panel} />}
              trigger={["click"]}>
              <a className={`ant-dropdown-link Nav_a ${url === "panel" && "active"}`}>
                Panels <FaAngleDown style={{ verticalAlign: "middle" }} />
              </a>
            </Dropdown>
          )}
        </Col>
        <Col className="mobileNav" span={2}>
          {notClickable ? (
            <div onClick={ALERT} className={`Nav_a`}>
              Messages
            </div>
          ) : (
            <Link
              to="/organizer/messages/chat"
              className={`Nav_a ${url === "messages" && "active"}`}>
              Messages
            </Link>
          )}
        </Col>
        <Col className="mobileNav" span={6}>
          <Form
            style={{ display: "flex", alignItems: "center", height: "100%" }}
            onFinish={() => {
              if (text?.trim().length > 0 && !notClickable) {
                navigate(`/organizer/search/${text}`, { state: text });
              } else if (notClickable) ALERT();
            }}>
            <Form.Item
              style={{
                margin: "0px",
                width: "85%"
              }}
              name="search">
              <Input
                size="middle"
                className="navinput"
                defaultValue={query}
                value={text}
                onChange={(e) => settext(e.currentTarget.value)}
                placeholder="Search"
                prefix={
                  <FaSearch
                    onClick={() => {
                      if (text?.trim().length > 0 && !notClickable) {
                        navigate(`/organizer/search/${text}`, { state: text });
                      } else if (notClickable) ALERT();
                    }}
                    style={{
                      cursor: "pointer",
                      color: "#8F8F8F",
                      marginRight: "10px",
                      width: "25px",
                      height: "16px"
                    }}
                  />
                }
              />
            </Form.Item>
          </Form>
        </Col>

        <Col className="mobileNav mobileNavFlex" span={6}>
          <Badge className="belldot" dot>
            <div style={{ position: "relative" }}>
              <FaBell
                style={{
                  marginLeft: "0",
                  fontSize: 22,
                  cursor: "pointer"
                }}
                onClick={() => {
                  if (notClickable) ALERT();
                  else navigate(`/organizer/notifications`); //setOpen((e) => !e);
                }}
              />
              {open && !notClickable ? <Notification open={open} setOpen={setOpen} /> : null}
            </div>
          </Badge>
          <div
            ref={u}
            style={{
              position: "relative",
              marginLeft: "10px",
              display: "flex",
              alignItems: "center"
            }}>
            <Dropdown
              getPopupContainer={() => u.current}
              overlayStyle={{ minWidth: "170px" }}
              placement="bottom"
              overlay={<Menu items={UserItems} />}
              trigger={["click"]}>
              <a
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  marginLeft: "10px",
                  overflowY: "hidden"
                }}
                className={`ant-dropdown-link Nav_a`}
                onClick={(e) => {
                  e.preventDefault();
                }}>
                <FadeInImage
                  type="Fadenavprofile"
                  fallaback={fallbackprofile}
                  src={KEYS.API + "/" + viewer?.profile}
                />
                <span
                  style={{
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    maxWidth: "150px",
                    display: "inline-block",
                    userSelect: "none",
                    fontSize: "15px",
                    fontWeight: "600",
                    marginLeft: "10px"
                  }}>
                  {viewer?.name}
                </span>
                <span>
                  <FaAngleDown
                    style={{
                      marginLeft: "5px",
                      verticalAlign: "middle"
                    }}
                  />
                </span>
              </a>
            </Dropdown>
          </div>
        </Col>
      </Row>
      <div className="mobileNavhide">
        <Link to="/">
          <img className="navlogo" height="40px" src="/images/logo.png" alt="logo" />
        </Link>

        <Row align="center" style={{ padding: "0" }}>
          <Row
            style={{
              gap: "15px"
            }}>
            <Col
              className="drawerpadding"
              style={{
                paddingInline: "0",
                paddingTop: "0",
                position: "relative",
                top: "6px"
              }}>
              {notClickable ? (
                <div></div>
              ) : (
                <Link to="/organizer/messages/chat">
                  <AiTwotoneMessage
                    style={{
                      marginLeft: "0",
                      fontSize: 17.5,
                      cursor: "pointer"
                    }}
                  />
                </Link>
              )}
            </Col>
            <Col
              className="drawerpadding"
              style={{
                paddingInline: "0",
                paddingTop: "0",
                position: "relative",
                top: "6px"
              }}>
              {" "}
              {notClickable ? (
                <div onClick={ALERT}>{}</div>
              ) : (
                <Link to={"/organizer/notifications"}>
                  <Badge dot>
                    <FaBell
                      style={{
                        marginLeft: "0",
                        fontSize: 17.5,
                        cursor: "pointer"
                      }}
                    />
                  </Badge>
                </Link>
              )}
            </Col>
          </Row>

          <Button className="drawertogglebutton" type="primary" onClick={showDrawer}>
            <FaBars style={{ verticalAlign: "middle" }} />
          </Button>
        </Row>
      </div>
    </Fragment>
  );
};

export default OrganizerNav;
